function calculateMonitorArmStock(){
  // console.log('stock is calculated again!');
  var alreadyClicked = false;
  $('.upsell_cart_item_type_mob_input__js').each(function() {
    if ($(this).closest('.upsell_item_li').attr('style') != 'display: none;'){
      if ($(this).closest('.upsell_item_li').hasClass('variantNotInStock')){
      }
      else{
        if(alreadyClicked == false){
          $(this).closest('.upsell_item_li').trigger('click');
          alreadyClicked = true;
        }
      }
    }
  });
  alreadyClicked = false;
  $('.upsell_cart_item_type_2_input__js').each(function() {
    if ($(this).closest('.upsell_item_li').attr('style') != 'display: none;'){
      if ($(this).closest('.upsell_item_li').hasClass('variantNotInStock')){
      }
      else{
        if(alreadyClicked == false){
          $(this).closest('.upsell_item_li').trigger('click');
          alreadyClicked = true;
        }
      }
    }
  });
  alreadyClicked = false;
  $('.upsell_cart_item_type_cart_input__js').each(function() {
    // console.log($(this).closest('.upsell_item_li').attr('style'));
    if ($(this).closest('.upsell_item_li').attr('style') != 'display: block;'){
      if ($(this).closest('.upsell_item_li').hasClass('variantNotInStock')){
        console.log('here not');
      }
      else{
        if(alreadyClicked == false){
          // console.log($(this).closest('.upsell_item_li').attr('data-name'));
          $(this).closest('.upsell_item_li').trigger('click');
          alreadyClicked = true;
        }
      }
    }
  });

  setTimeout(function(){
    $('.upsell_item_li').each(function(){
      if ( $(this).find('input:checked').length > 0 ) {
          $(this).trigger('click');
      }
    });
  },100);
}

$(document).ready(function(){
  var hasOosVariants = 0;
  $('.upsell_item_li').each(function(){
    if($(this).hasClass('variantNotInStock')){
      hasOosVariants++;
    }
  });
  if(hasOosVariants != 0){
    calculateMonitorArmStock();
  }
  
});



class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      // cartItems.updateQuantity(this.dataset.index, 0);
      var attributeId = $(this).closest('.cart-item').attr('data-id');
      console.log( attributeId, 'ATTRIBUTE ID');
      cartItems.removeItem(attributeId, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      if (event.target.type !== 'radio') this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  removeQuantity(id, quantity){

    var currentUrl = String(window.location.href);
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: JSON.stringify({ updates: { [id]: quantity } }), 
      dataType: "json",
      contentType: "application/json", 
      success: function (formData) {
        console.log("Cart updated successfully!", formData);
        if (currentUrl.indexOf('cart') != -1){
          updateCartPage();
        }
        else{
          updateDrawer();
        }
      },
      error: function (error) {
        console.error("Error updating cart:", error);
      },
    });
  }

  removeItem(id, quantity){

    var currentUrl = String(window.location.href);
    var data = {
        id: id,
        quantity: 0,
      };

    jQuery.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: data,
        dataType: "json",
        success: function() {
          if (currentUrl.indexOf('cart') != -1){
            updateCartPage();
          }
          else{
            updateDrawer();
          }
        },
        error: function() {
          if (currentUrl.indexOf('cart') != -1){
            updateCartPage();
          }
          else{
            updateDrawer();
          }
          console.error("Error updating cart:", error);
        }
    });
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings?.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();

      var currentId = event.target.closest('.cart-item').getAttribute('data-id');

      setTimeout(() => {
        const cartItem = event.target.closest('.cart-item');
        var currentQty = event.target.closest('.cart-item').querySelector('.quantity__input').value;

        if (cartItem) {
          const removeButton = cartItem.querySelector('cart-remove-button');
          
          if (removeButton) {
            removeButton.classList.add('loading');
          }
        }

        var items = [];
        items.push({
          id: parseInt(currentId),
          quantity: parseInt(currentQty),
        });

        var currentUrl = String(window.location.href);

        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: JSON.stringify({ updates: { [currentId]: currentQty } }), 
          dataType: "json",
          contentType: "application/json", 
          success: function (formData) {
            console.log("Cart updated successfully!", formData);
            if (currentUrl.indexOf('cart') != -1){
              updateCartPage();
            }
            else{
              updateDrawer();
            }
          },
          error: function (error) {
            console.error("Error updating cart:", error);
            if (currentUrl.indexOf('cart') != -1){
              updateCartPage();
            }
            else{
              updateDrawer();
            }
          },
        });

        
      }, 1000);
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;

          console.log('update2');

        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'header-icons',
        section: document.getElementById('header-icons').dataset.id,
        selector: '.js-drawer-open-button-right',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      }
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        console.log(parsedState.item_count, 'TESTING HERE');

        $('.js-drawer-open-button-right').toggleClass('is-empty', parsedState.item_count === 0);
        $(this).toggleClass('is-empty', parsedState.item_count === 0);

        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );

          if (section.id == 'main-cart-items') {
            document.querySelector('#main-cart-items .total-block').innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              '#main-cart-items .total-block'
            );

            window.cartDrawer.initUpsellCartSlider();
          }
        });
        window.cartDrawer.initUpsellSlider();
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    if (document.querySelector(".mobile-upsells.close") && selector == '.drawer__wrapper') {
        const parsedDocument = new DOMParser().parseFromString(html, "text/html");
        const newElement = parsedDocument.querySelector(selector);
        newElement.querySelector(".mobile-upsells")?.classList.add("close");
        return newElement.outerHTML;
    }
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}


function updateDrawer() {
  fetch(window.location.href)
  .then(response => response.text())
  .then(html => {

    const $doc = $(html);
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newDrawer = doc.querySelector('#CartDrawer .drawer__wrapper');
    const currentDrawer = document.querySelector('#CartDrawer .drawer__wrapper');

    if (newDrawer && currentDrawer) {
      if (currentDrawer.querySelector(".mobile-upsells.close")) {
        newDrawer.querySelector(".mobile-upsells")?.classList.add("close");
      }
      currentDrawer.innerHTML = newDrawer.innerHTML;
    }

    document.dispatchEvent(new CustomEvent('cart:rendered'));

    const cartCount = doc.querySelector('#header-icons .js-drawer-open-button-right');
    const currentCartCount = document.querySelector('#header-icons .js-drawer-open-button-right');

    if (cartCount && currentCartCount) {
      currentCartCount.innerHTML = cartCount.innerHTML;
    }


    jQuery.getJSON("/cart.js", function (cart) {
      var cartCounted = cart.item_count;
      if (cartCounted == 0) {
        document.querySelector('#cart-drawer').classList.add('is-empty');
      } else {
        document.querySelector('#cart-drawer').classList.remove('is-empty');
      }
    });
    document.querySelector('#cart-drawer').classList.add('active');
    document.body.classList.add('overflow-hidden');

    initUpsellSlider();
    calculateMonitorArmStock();

    
  })
  .catch(error => console.error('Error Cart Drawer:', error));

  setTimeout(function(){
    window.setStockNote();
  },1000);
  
}


function updateCartPage() {
  fetch(window.location.href)
  .then(response => response.text())
  .then(html => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newCart = doc.querySelector('#main-cart-items');
    const currenCart = document.querySelector('#main-cart-items');

    if (newCart && currenCart) {
      currenCart.innerHTML = newCart.innerHTML;
    }

    const cartCount = doc.querySelector('#header-icons .js-drawer-open-button-right');
    const currentCartCount = document.querySelector('#header-icons .js-drawer-open-button-right');

    if (cartCount && currentCartCount) {
      currentCartCount.innerHTML = cartCount.innerHTML;
    }
    document.dispatchEvent(new CustomEvent('cart:rendered'));

    jQuery.getJSON("/cart.js", function (cart) {
      var cartCounted = cart.item_count;
      if (cartCounted == 0) {
        $('cart-items').addClass('is-empty');
      } else {
        $('cart-items').removeClass('is-empty');
      }
    });

    initUpsellCartSlider();
    calculateMonitorArmStock();
  })
  .catch(error => console.error('Error Cart Drawer:', error));
}

function initUpsellSlider() {
  new Swiper('.mobile-upsells-swiper', {
    slidesPerView: 1.11,
    spaceBetween: 40,
    loop: false, 
    navigation: {
      nextEl: ".drawer__button-next-mob",
      prevEl: ".drawer__button-prev-mob",
    },
    pagination: {
      el: ".drawer .swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + ' bullet">'+"</span>";
      },
    },
  });
}

function initUpsellCartSlider() {
  window.addOneModalHandler();
  new Swiper('.upsells-cart', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    loop: false, 
    navigation: {
      nextEl: ".upsells-cart__button-next-mob",
      prevEl: ".upsells-cart__button-prev-mob",
    },
    breakpoints: {
      992: {
        spaceBetween: 20,
      },
    },
  });
}


function presetCardReviews() {
  var ReviewsSetted = 0;
  var intervalId = setInterval(function() {
      if (ReviewsSetted == 500) {
          clearInterval(intervalId);
          return;
      }
      $('.product_cart__info').each(function(){
        var currentCounter = $(this).find('.ruk-rating-snippet-count').html();
        // console.log(currentCounter, 'TESTING COUNTER');
        if (typeof currentCounter != 'undefined') {
          $(this).find('.main_product_rating_actual__js_carted').html(currentCounter);
          ReviewsSetted = ReviewsSetted + 1;
        }
      });
      
  }, 200);
}

presetCardReviews();